import o,{keyframes as r}from"styled-components";const t=r`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`,i=o.div`
	width: 48px;
	height: 48px;
	border: 5px solid #171717;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: ${t} 1s linear infinite;
`;export{i as SpinnerContainer};
